import { takeLatest, put, call, all } from 'redux-saga/effects';
import { resetApiToken } from '@api/user';
import {
  API_TOKEN_RESET_STARTED,
  resetApiTokenSucceeded,
  resetApiTokenFailed,
} from '@redux/ducks/userDetails/apiToken';
import { setUserApiToken } from '@redux/ducks/userDetails/userDetails';

// Watchers

export function* watchResetApiToken() {
  yield takeLatest(API_TOKEN_RESET_STARTED, resetApiTokenTask);
}

// Workers

export function* resetApiTokenTask({ payload }) {
  try {
    const resp = yield call(resetApiToken, payload);

    yield put(setUserApiToken(resp));
    yield put(resetApiTokenSucceeded());
  } catch (err) {
    yield put(resetApiTokenFailed(err.data));
  }
}

// Saga

export default function* apiTokenSaga() {
  yield all([watchResetApiToken()]);
}
